// Trilingual strings for the Hotel Ops staff experience (Phase C).
export const STAFF_TEXT = {
    en: {
        staffTitle: 'Hotel Ops',
        staffPortalTitle: 'Staff Portal',
        pinTitle: 'Hotel Ops access',
        pinTitleGeneric: 'Staff access',
        pinPrompt: 'Enter your 4-digit staff PIN',
        pinInvalid: 'Invalid PIN. Please try again.',
        noCapabilities: 'No hotel functions are assigned to you. Please contact your manager.',
        verify: 'Continue',
        verifying: 'Verifying\u2026',
        continueAs: 'Continue as logged-in user',
        hubTitle: 'Your workspace',
        hello: 'Hello',
        switchUser: 'Done / Switch user',
        locked: 'Session locked for your security. Please identify yourself again.',
        housekeeping: 'Housekeeping',
        housekeepingTag: 'Rooms, DND and readiness',
        security: 'Security',
        securityTag: 'Guest security requests',
        concierge: 'Concierge',
        conciergeTag: 'Guest service requests',
        management: 'Management',
        managementTag: 'Operations summary',
        floor: 'Floor',
        arrivedFloor: 'You are working',
        floorRoomsTitle: 'Room status',
        stateRed: 'Needs attention',
        stateOrange: 'Do Not Disturb',
        stateGreen: 'Ready',
        needsAttention: 'Needs attention',
        inProgressDnd: 'Do Not Disturb',
        allTools: 'View all tools',
        rooms: 'Rooms',
        noFloorRooms: 'No rooms are configured for this floor yet.',
        updateRoomStatus: 'Update room status',
        hi: 'Hi',
        enterRoomTitle: 'Enter room number',
        roomPlaceholder: 'e.g. 302',
        continueBtn: 'Continue',
        roomNotFound: 'Room not found on this floor.',
        roomWrongFloor: 'That room is not on this floor.',
        currentStatus: 'Current status',
        startServicing: 'Start servicing',
        markRoomReady: 'Mark Ready',
        needsAttentionBtn: 'Needs attention',
        reasonLabel: 'Reason (required)',
        reasonPlaceholder: 'What needs attention?',
        reasonRequired: 'Please enter a reason.',
        invalidTransition: 'That status change is not allowed.',
        statusUpdated: 'Status updated',
        lastCleanedBy: 'Last cleaned by',
        enterAnother: 'Update another room',
        photoOptional: 'Photo (optional)',
        addPhoto: 'Add photo',
        beingServiced: 'Being Serviced / DND',
        networkError: 'Action did not complete. Please try again.',
        unknown: 'NOT SET',
        ready: 'READY',
        notReady: 'NOT READY',
        dndUntil: 'DND until',
        markReady: 'Mark Clean / Ready',
        open: 'Open',
        resolvedTab: 'Resolved',
        assignedToMe: 'Assigned to me',
        allWork: 'All Work', allWorkTag: 'Every category at your location',
        cat: { maintenance: 'Maintenance', parking: 'Parking', waste_recycling: 'Waste & Recycling', amenities: 'Amenities', building: 'Building' },
        hubIntro: 'Here is your work. Tap an area to see and handle requests.',
        allClear: 'All clear',
        ahTitle: 'Recent actions', ahEmpty: 'Nothing yet — your recent actions will appear here.',
        ahClearAll: 'Clear all', ahRemove: 'Remove from my list',
        ahFootnote: 'This is your own list. Removing an item never changes the record.',
        ahAcknowledge: 'Acknowledged', ahResolve: 'Resolved', ahCancel: 'Cancelled',
        opsSummaryTitle: 'Operations summary',
        queueHelp: 'Tap a request for details. Acknowledge when you start it, Resolve when it is done.',
        areaDesc: {
            housekeeping: 'Room readiness, cleaning and Do-Not-Disturb',
            security: 'Safety and security issues',
            concierge: 'Guest and resident service requests',
            valet: 'Vehicle retrieval requests',
            maintenance: 'Repairs and fix-it requests',
            parking: 'Parking issues and violations',
            waste_recycling: 'Garbage, recycling and chute issues',
            amenities: 'Pool, gym and shared facilities',
            building: 'Doors, elevators, lighting and common areas',
            all: 'Every open request across your property',
            manager: 'Team performance at a glance',
        },
        urgent: 'URGENT',
        standard: 'Standard',
        room: 'Room',
        valet: 'Valet',
        valetTag: 'Vehicle retrieval requests',
        plate: 'Plate',
        valetRequestedFor: 'Requested for',
        valetAttendant: 'Attendant',
        valetStartRetrieving: 'Start retrieving',
        valetMarkReady: 'Vehicle ready',
        valetMarkDelivered: 'Delivered',
        valetCancel: 'Cancel',
        valetLookup: 'Look up',
        valetLookupPh: 'Ticket # (e.g. 4827)',
        valetNotFound: 'No vehicle found for that ticket.',
        valetClearLookup: 'Clear lookup',
        valetEmpty: 'No open valet requests.',
        valet_retrieval_requested: 'Retrieval requested',
        valet_retrieving: 'Retrieving',
        valet_ready: 'Ready',
        valet_delivered: 'Delivered',
        valet_cancelled: 'Cancelled',
        submitted: 'Submitted',
        status: 'Status',
        statusLabels: { open: 'Open', acknowledged: 'Acknowledged', resolved: 'Resolved' },
        acknowledge: 'Acknowledge',
        resolve: 'Resolve',
        notesPlaceholder: 'Resolution notes (optional)',
        handledBy: 'Handled by',
        noRequests: 'No requests right now.',
        noRooms: 'No rooms in the registry.',
        refresh: 'Refresh',
        back: 'Back',
        summaryTitle: 'Operations summary (last 7 days)',
        openNow: 'Open now',
        urgentOpen: 'Urgent open',
        resolved7d: 'Resolved (7d)',
        avgResponse: 'Avg response',
        avgResolution: 'Avg resolution',
        min: 'min',
        dndRooms: 'DND rooms',
        readyRooms: 'Ready rooms',
        trackedRooms: 'Tracked rooms',
        error: 'Something went wrong. Please try again.',
        selectSector: 'What are you here to do?',
        selectSectorHint: 'Choose your area to continue',
        notAuthorizedSector: "You're not authorized for this area. Please choose another.",
        goodMorning: 'Good morning',
        goodAfternoon: 'Good afternoon',
        goodEvening: 'Good evening',
        entering: 'Entering',
        roomDetails: 'Room details',
        requestDetail: 'Request detail',
        tapForDetails: 'Tap for full detail',
        createdLabel: 'Requested',
        seenLabel: 'Seen / received',
        resolvedLabel: 'Resolved',
        responseTime: 'Response time',
        resolutionTime: 'Resolution time',
        notFinished: 'Not yet',
        clearHistory: 'Clear history',
        historyCleared: 'History cleared from this device. Records are kept for managers.',
        // Routing — send work to the right department, or push it to management.
        routeElsewhere: 'Send to another department',
        routeTitle: 'Where should this go?',
        routeHelp: 'It leaves your list and arrives in theirs. The guest keeps seeing the same request.',
        routeConfirm: 'Send',
        routeCancel: 'Cancel',
        routeReasonPlaceholder: 'Why are you sending it? (optional)',
        routeFailed: 'Could not send it. Try again.',
        hkRequests: 'Requests',
        hkRequestsHelp: 'Guest requests routed to housekeeping',
        dept: {
            housekeeping: 'Housekeeping', security: 'Security', concierge: 'Guest Requests',
            maintenance: 'Maintenance', parking: 'Parking', waste_recycling: 'Waste & Recycling',
            amenities: 'Amenities', building: 'Building', valet: 'Valet', management: 'Management',
        },
        sectorOpenBtn: 'Open',
        notifSuffix: 'open',
        noEventsYet: 'No activity yet',
        guest: 'Guest',
        vacant: 'No active guest',
        checkOut: 'Checkout',
        noActivity: 'No activity yet',
        viewDetails: 'View details',
        firstTimeSetup: 'First time? Set up PIN',
        forgotPin: 'Forgot PIN?',
        setupTitle: 'Set up your Staff PIN',
        setupPrompt: 'Confirm your work email, then choose a unique 4-digit PIN.',
        emailPlaceholder: 'Work email',
        newPinPlaceholder: 'New 4-digit PIN',
        confirmPinPlaceholder: 'Confirm PIN',
        createPin: 'Create PIN',
        pinMismatch: 'PINs do not match. Please try again.',
        pinExists: 'A PIN already exists for this account. Use "Forgot PIN" to reset it.',
        emailNotRecognized: 'That email is not recognized for this location. Ask an administrator to add your email.',
        pinCreatedOk: 'PIN created. You can now sign in with your new PIN.',
        forgotTitle: 'Reset your Staff PIN',
        forgotPrompt: 'Enter your work email and we will send a secure reset link.',
        sendResetLink: 'Send reset link',
        pinForgotSent: 'If an account exists with that email, a reset link has been sent. Check your inbox.',
        tooManyRequests: 'Too many requests. Please try again later.',
        pinEmailUnavailable: 'PIN reset email is unavailable right now. Please contact an administrator.',
        resetTitle: 'Create a new PIN',
        resetPrompt: 'Choose a new 4-digit PIN. Your old PIN will stop working immediately.',
        setNewPin: 'Set new PIN',
        pinResetOk: 'Your PIN has been reset. Sign in with your new PIN.',
        pinResetInvalid: 'This reset link is invalid or has expired. Please request a new one.',
    },
    fr: {
        staffTitle: 'Op\u00e9rations h\u00f4tel',
        staffPortalTitle: 'Portail du personnel',
        pinTitle: 'Acc\u00e8s du personnel',
        pinTitleGeneric: 'Acc\u00e8s du personnel',
        pinPrompt: 'Entrez votre NIP de 4 chiffres',
        pinInvalid: 'NIP invalide. Veuillez r\u00e9essayer.',
        noCapabilities: "Aucune fonction h\u00f4teli\u00e8re ne vous est attribu\u00e9e. Contactez votre gestionnaire.",
        verify: 'Continuer',
        verifying: 'V\u00e9rification\u2026',
        continueAs: 'Continuer en tant qu\u2019utilisateur connect\u00e9',
        hubTitle: 'Votre espace de travail',
        hello: 'Bonjour',
        switchUser: 'Termin\u00e9 / Changer d\u2019utilisateur',
        locked: 'Session verrouill\u00e9e pour votre s\u00e9curit\u00e9. Veuillez vous identifier \u00e0 nouveau.',
        housekeeping: 'Entretien m\u00e9nager',
        housekeepingTag: 'Chambres, NPD et disponibilit\u00e9',
        security: 'S\u00e9curit\u00e9',
        securityTag: 'Demandes de s\u00e9curit\u00e9 des clients',
        concierge: 'Conciergerie',
        conciergeTag: 'Demandes de service des clients',
        management: 'Gestion',
        managementTag: 'Sommaire des op\u00e9rations',
        floor: '\u00c9tage',
        arrivedFloor: 'Vous travaillez',
        floorRoomsTitle: 'Statut des chambres',
        stateRed: 'Attention requise',
        stateOrange: 'Ne pas d\u00e9ranger',
        stateGreen: 'Pr\u00eate',
        needsAttention: 'Attention requise',
        inProgressDnd: 'Ne pas d\u00e9ranger',
        allTools: 'Voir tous les outils',
        rooms: 'Chambres',
        noFloorRooms: 'Aucune chambre configur\u00e9e pour cet \u00e9tage.',
        updateRoomStatus: 'Mettre \u00e0 jour une chambre',
        hi: 'Bonjour',
        enterRoomTitle: 'Entrez le num\u00e9ro de chambre',
        roomPlaceholder: 'ex. 302',
        continueBtn: 'Continuer',
        roomNotFound: 'Chambre introuvable sur cet \u00e9tage.',
        roomWrongFloor: "Cette chambre n'est pas sur cet \u00e9tage.",
        currentStatus: 'Statut actuel',
        startServicing: 'Commencer le service',
        markRoomReady: 'Marquer pr\u00eate',
        needsAttentionBtn: 'Attention requise',
        reasonLabel: 'Raison (obligatoire)',
        reasonPlaceholder: "Qu'est-ce qui requiert de l'attention\u00a0?",
        reasonRequired: 'Veuillez indiquer une raison.',
        invalidTransition: "Ce changement de statut n'est pas autoris\u00e9.",
        statusUpdated: 'Statut mis \u00e0 jour',
        lastCleanedBy: 'Derni\u00e8re nettoyage par',
        enterAnother: 'Mettre \u00e0 jour une autre chambre',
        photoOptional: 'Photo (optionnel)',
        addPhoto: 'Ajouter une photo',
        beingServiced: 'En service / Ne pas d\u00e9ranger',
        networkError: "L'action n'a pas abouti. Veuillez r\u00e9essayer.",
        ready: 'PR\u00caTE',
        unknown: 'NON D\u00c9FINI',
        notReady: 'NON PR\u00caTE',
        dndUntil: 'NPD jusqu\u2019\u00e0',
        markReady: 'Marquer propre / pr\u00eate',
        open: 'Ouvertes',
        resolvedTab: 'R\u00e9solues',
        assignedToMe: 'Assignées à moi',
        allWork: 'Tout le travail', allWorkTag: 'Toutes les catégories de votre établissement',
        cat: { maintenance: 'Entretien', parking: 'Stationnement', waste_recycling: 'Déchets et recyclage', amenities: 'Commodités', building: 'Bâtiment' },
        hubIntro: 'Voici votre travail. Touchez un secteur pour voir et traiter les demandes.',
        allClear: 'Rien à signaler',
        ahTitle: 'Actions récentes', ahEmpty: 'Rien pour le moment — vos actions récentes appara\u00eetront ici.',
        ahClearAll: 'Tout effacer', ahRemove: 'Retirer de ma liste',
        ahFootnote: 'Ceci est votre liste personnelle. Retirer un élément ne modifie jamais le dossier.',
        ahAcknowledge: 'Prise en charge', ahResolve: 'Résolue', ahCancel: 'Annulée',
        opsSummaryTitle: 'Sommaire des opérations',
        queueHelp: 'Touchez une demande pour les détails. Prenez en charge au début, Résolvez une fois terminée.',
        areaDesc: {
            housekeeping: 'Disponibilité des chambres, ménage et Ne pas déranger',
            security: 'Problèmes de sûreté et de sécurité',
            concierge: 'Demandes de service des clients et résidents',
            valet: 'Demandes de récupération de véhicule',
            maintenance: 'Réparations et demandes de dépannage',
            parking: 'Problèmes et infractions de stationnement',
            waste_recycling: 'Ordures, recyclage et vide-ordures',
            amenities: 'Piscine, gym et espaces communs',
            building: 'Portes, ascenseurs, éclairage et aires communes',
            all: 'Toutes les demandes ouvertes de votre établissement',
            manager: "Performance de l'équipe en un coup d'œil",
        },
        urgent: 'URGENT',
        standard: 'Standard',
        room: 'Chambre',
        valet: 'Voiturier',
        valetTag: 'Demandes de v\u00e9hicules',
        plate: 'Plaque',
        valetRequestedFor: 'Demand\u00e9 pour',
        valetAttendant: 'Pr\u00e9pos\u00e9',
        valetStartRetrieving: 'R\u00e9cup\u00e9rer',
        valetMarkReady: 'V\u00e9hicule pr\u00eat',
        valetMarkDelivered: 'Livr\u00e9',
        valetCancel: 'Annuler',
        valetLookup: 'Rechercher',
        valetLookupPh: 'Billet no (ex. 4827)',
        valetNotFound: 'Aucun v\u00e9hicule pour ce billet.',
        valetClearLookup: 'Effacer la recherche',
        valetEmpty: 'Aucune demande de voiturier en cours.',
        valet_retrieval_requested: 'R\u00e9cup\u00e9ration demand\u00e9e',
        valet_retrieving: 'En r\u00e9cup\u00e9ration',
        valet_ready: 'Pr\u00eat',
        valet_delivered: 'Livr\u00e9',
        valet_cancelled: 'Annul\u00e9',
        submitted: 'Soumise',
        status: 'Statut',
        statusLabels: { open: 'Ouverte', acknowledged: 'Prise en charge', resolved: 'R\u00e9solue' },
        acknowledge: 'Prendre en charge',
        resolve: 'R\u00e9soudre',
        notesPlaceholder: 'Notes de r\u00e9solution (facultatif)',
        handledBy: 'Trait\u00e9e par',
        noRequests: 'Aucune demande pour le moment.',
        noRooms: 'Aucune chambre dans le registre.',
        refresh: 'Actualiser',
        back: 'Retour',
        summaryTitle: 'Sommaire des op\u00e9rations (7 derniers jours)',
        openNow: 'Ouvertes',
        urgentOpen: 'Urgentes ouvertes',
        resolved7d: 'R\u00e9solues (7 j)',
        avgResponse: 'R\u00e9ponse moy.',
        avgResolution: 'R\u00e9solution moy.',
        min: 'min',
        dndRooms: 'Chambres NPD',
        readyRooms: 'Chambres pr\u00eates',
        trackedRooms: 'Chambres suivies',
        error: 'Une erreur est survenue. Veuillez r\u00e9essayer.',
        selectSector: 'Que venez-vous faire\u00a0?',
        selectSectorHint: 'Choisissez votre secteur pour continuer',
        notAuthorizedSector: "Vous n'\u00eates pas autoris\u00e9 pour ce secteur. Veuillez en choisir un autre.",
        goodMorning: 'Bonjour',
        goodAfternoon: 'Bon apr\u00e8s-midi',
        goodEvening: 'Bonsoir',
        entering: 'Acc\u00e8s',
        roomDetails: 'D\u00e9tails de la chambre',
        requestDetail: 'D\u00e9tail de la demande',
        tapForDetails: 'Toucher pour le d\u00e9tail complet',
        createdLabel: 'Demand\u00e9e',
        seenLabel: 'Vue / re\u00e7ue',
        resolvedLabel: 'R\u00e9solue',
        responseTime: 'Temps de r\u00e9ponse',
        resolutionTime: 'Temps de r\u00e9solution',
        notFinished: 'Pas encore',
        clearHistory: "Effacer l'historique",
        historyCleared: "Historique effac\u00e9 de cet appareil. Les enregistrements sont conserv\u00e9s pour les gestionnaires.",
        routeElsewhere: 'Envoyer à un autre service',
        routeTitle: 'Où cela doit-il aller ?',
        routeHelp: "Cela quitte votre liste et arrive dans la leur. Le client voit toujours la même demande.",
        routeConfirm: 'Envoyer',
        routeCancel: 'Annuler',
        routeReasonPlaceholder: 'Pourquoi l’envoyez-vous ? (facultatif)',
        routeFailed: "Envoi impossible. Réessayez.",
        hkRequests: 'Demandes',
        hkRequestsHelp: "Demandes des clients dirigées vers l'entretien ménager",
        dept: {
            housekeeping: 'Entretien ménager', security: 'Sécurité', concierge: 'Demandes des clients',
            maintenance: 'Entretien', parking: 'Stationnement', waste_recycling: 'Déchets et recyclage',
            amenities: 'Commodités', building: 'Bâtiment', valet: 'Voiturier', management: 'Direction',
        },
        sectorOpenBtn: 'Ouvrir',
        notifSuffix: 'en cours',
        noEventsYet: 'Aucune activit\u00e9 pour le moment',
        guest: 'Client',
        vacant: 'Aucun client actif',
        checkOut: 'D\u00e9part',
        noActivity: 'Aucune activit\u00e9 pour le moment',
        viewDetails: 'Voir les d\u00e9tails',
        firstTimeSetup: 'Premi\u00e8re fois\u00a0? Cr\u00e9er un NIP',
        forgotPin: 'NIP oubli\u00e9\u00a0?',
        setupTitle: 'Cr\u00e9ez votre NIP employ\u00e9',
        setupPrompt: 'Confirmez votre courriel professionnel, puis choisissez un NIP unique \u00e0 4 chiffres.',
        emailPlaceholder: 'Courriel professionnel',
        newPinPlaceholder: 'Nouveau NIP \u00e0 4 chiffres',
        confirmPinPlaceholder: 'Confirmer le NIP',
        createPin: 'Cr\u00e9er le NIP',
        pinMismatch: 'Les NIP ne correspondent pas. Veuillez r\u00e9essayer.',
        pinExists: 'Un NIP existe d\u00e9j\u00e0 pour ce compte. Utilisez \u00ab\u00a0NIP oubli\u00e9\u00a0\u00bb pour le r\u00e9initialiser.',
        emailNotRecognized: "Ce courriel n'est pas reconnu pour cet \u00e9tablissement. Demandez \u00e0 un administrateur d'ajouter votre courriel.",
        pinCreatedOk: 'NIP cr\u00e9\u00e9. Vous pouvez maintenant vous connecter avec votre nouveau NIP.',
        forgotTitle: 'R\u00e9initialiser votre NIP employ\u00e9',
        forgotPrompt: 'Saisissez votre courriel professionnel et nous vous enverrons un lien de r\u00e9initialisation s\u00e9curis\u00e9.',
        sendResetLink: 'Envoyer le lien',
        pinForgotSent: 'Si un compte existe avec ce courriel, un lien de r\u00e9initialisation a \u00e9t\u00e9 envoy\u00e9. Consultez votre bo\u00eete de r\u00e9ception.',
        tooManyRequests: 'Trop de demandes. Veuillez r\u00e9essayer plus tard.',
        pinEmailUnavailable: "L'envoi du courriel de r\u00e9initialisation est indisponible. Veuillez contacter un administrateur.",
        resetTitle: 'Cr\u00e9er un nouveau NIP',
        resetPrompt: 'Choisissez un nouveau NIP \u00e0 4 chiffres. Votre ancien NIP cessera imm\u00e9diatement de fonctionner.',
        setNewPin: 'D\u00e9finir le NIP',
        pinResetOk: 'Votre NIP a \u00e9t\u00e9 r\u00e9initialis\u00e9. Connectez-vous avec votre nouveau NIP.',
        pinResetInvalid: 'Ce lien de r\u00e9initialisation est invalide ou expir\u00e9. Veuillez en demander un nouveau.',
    },
    es: {
        staffTitle: 'Operaciones del hotel',
        staffPortalTitle: 'Portal del personal',
        pinTitle: 'Acceso del personal',
        pinTitleGeneric: 'Acceso del personal',
        pinPrompt: 'Ingrese su PIN de 4 d\u00edgitos',
        pinInvalid: 'PIN inv\u00e1lido. Intente de nuevo.',
        noCapabilities: 'No tiene funciones de hotel asignadas. Contacte a su gerente.',
        verify: 'Continuar',
        verifying: 'Verificando\u2026',
        continueAs: 'Continuar como usuario conectado',
        hubTitle: 'Su espacio de trabajo',
        hello: 'Hola',
        switchUser: 'Listo / Cambiar de usuario',
        locked: 'Sesi\u00f3n bloqueada por su seguridad. Identif\u00edquese de nuevo.',
        housekeeping: 'Limpieza',
        housekeepingTag: 'Habitaciones, NM y disponibilidad',
        security: 'Seguridad',
        securityTag: 'Solicitudes de seguridad de hu\u00e9spedes',
        concierge: 'Conserjer\u00eda',
        conciergeTag: 'Solicitudes de servicio de hu\u00e9spedes',
        management: 'Gerencia',
        managementTag: 'Resumen de operaciones',
        floor: 'Piso',
        arrivedFloor: 'Est\u00e1 trabajando',
        floorRoomsTitle: 'Estado de habitaciones',
        stateRed: 'Requiere atenci\u00f3n',
        stateOrange: 'No molestar',
        stateGreen: 'Lista',
        needsAttention: 'Requiere atenci\u00f3n',
        inProgressDnd: 'No molestar',
        allTools: 'Ver todas las herramientas',
        rooms: 'Habitaciones',
        noFloorRooms: 'A\u00fan no hay habitaciones configuradas para este piso.',
        updateRoomStatus: 'Actualizar habitaci\u00f3n',
        hi: 'Hola',
        enterRoomTitle: 'Ingrese el n\u00famero de habitaci\u00f3n',
        roomPlaceholder: 'ej. 302',
        continueBtn: 'Continuar',
        roomNotFound: 'Habitaci\u00f3n no encontrada en este piso.',
        roomWrongFloor: 'Esa habitaci\u00f3n no est\u00e1 en este piso.',
        currentStatus: 'Estado actual',
        startServicing: 'Iniciar servicio',
        markRoomReady: 'Marcar lista',
        needsAttentionBtn: 'Requiere atenci\u00f3n',
        reasonLabel: 'Motivo (obligatorio)',
        reasonPlaceholder: '\u00bfQu\u00e9 requiere atenci\u00f3n?',
        reasonRequired: 'Por favor indique un motivo.',
        invalidTransition: 'Ese cambio de estado no est\u00e1 permitido.',
        statusUpdated: 'Estado actualizado',
        lastCleanedBy: 'Limpiada por',
        enterAnother: 'Actualizar otra habitaci\u00f3n',
        photoOptional: 'Foto (opcional)',
        addPhoto: 'A\u00f1adir foto',
        beingServiced: 'En servicio / No molestar',
        networkError: 'La acci\u00f3n no se complet\u00f3. Int\u00e9ntelo de nuevo.',
        ready: 'LISTA',
        unknown: 'SIN ESTADO',
        notReady: 'NO LISTA',
        dndUntil: 'NM hasta',
        markReady: 'Marcar limpia / lista',
        open: 'Abiertas',
        resolvedTab: 'Resueltas',
        assignedToMe: 'Asignadas a mí',
        allWork: 'Todo el trabajo', allWorkTag: 'Todas las categorías de su ubicación',
        cat: { maintenance: 'Mantenimiento', parking: 'Estacionamiento', waste_recycling: 'Residuos y reciclaje', amenities: 'Comodidades', building: 'Edificio' },
        hubIntro: 'Este es su trabajo. Toque un área para ver y atender las solicitudes.',
        allClear: 'Todo al día',
        ahTitle: 'Acciones recientes', ahEmpty: 'Nada todavía — tus acciones recientes aparecerán aquí.',
        ahClearAll: 'Borrar todo', ahRemove: 'Quitar de mi lista',
        ahFootnote: 'Esta es tu propia lista. Quitar un elemento nunca cambia el registro.',
        ahAcknowledge: 'Atendida', ahResolve: 'Resuelta', ahCancel: 'Cancelada',
        opsSummaryTitle: 'Resumen de operaciones',
        queueHelp: 'Toque una solicitud para ver detalles. Atienda al empezar, Resuelva al terminar.',
        areaDesc: {
            housekeeping: 'Disponibilidad de habitaciones, limpieza y No molestar',
            security: 'Problemas de seguridad',
            concierge: 'Solicitudes de servicio de huéspedes y residentes',
            valet: 'Solicitudes de recuperación de vehículos',
            maintenance: 'Reparaciones y arreglos',
            parking: 'Problemas e infracciones de estacionamiento',
            waste_recycling: 'Basura, reciclaje y ducto de basura',
            amenities: 'Piscina, gimnasio y áreas compartidas',
            building: 'Puertas, ascensores, iluminación y áreas comunes',
            all: 'Todas las solicitudes abiertas de su propiedad',
            manager: 'Rendimiento del equipo de un vistazo',
        },
        urgent: 'URGENTE',
        standard: 'Est\u00e1ndar',
        room: 'Habitaci\u00f3n',
        valet: 'Valet',
        valetTag: 'Solicitudes de veh\u00edculos',
        plate: 'Matr\u00edcula',
        valetRequestedFor: 'Solicitado para',
        valetAttendant: 'Encargado',
        valetStartRetrieving: 'Recuperar',
        valetMarkReady: 'Veh\u00edculo listo',
        valetMarkDelivered: 'Entregado',
        valetCancel: 'Cancelar',
        valetLookup: 'Buscar',
        valetLookupPh: 'Boleto n.\u00ba (ej. 4827)',
        valetNotFound: 'Ning\u00fan veh\u00edculo con ese boleto.',
        valetClearLookup: 'Borrar b\u00fasqueda',
        valetEmpty: 'No hay solicitudes de valet abiertas.',
        valet_retrieval_requested: 'Recuperaci\u00f3n solicitada',
        valet_retrieving: 'En recuperaci\u00f3n',
        valet_ready: 'Listo',
        valet_delivered: 'Entregado',
        valet_cancelled: 'Cancelado',
        submitted: 'Enviada',
        status: 'Estado',
        statusLabels: { open: 'Abierta', acknowledged: 'En atenci\u00f3n', resolved: 'Resuelta' },
        acknowledge: 'Atender',
        resolve: 'Resolver',
        notesPlaceholder: 'Notas de resoluci\u00f3n (opcional)',
        handledBy: 'Atendida por',
        noRequests: 'No hay solicitudes por ahora.',
        noRooms: 'No hay habitaciones en el registro.',
        refresh: 'Actualizar',
        back: 'Volver',
        summaryTitle: 'Resumen de operaciones (\u00faltimos 7 d\u00edas)',
        openNow: 'Abiertas',
        urgentOpen: 'Urgentes abiertas',
        resolved7d: 'Resueltas (7 d)',
        avgResponse: 'Respuesta prom.',
        avgResolution: 'Resoluci\u00f3n prom.',
        min: 'min',
        dndRooms: 'Habitaciones NM',
        readyRooms: 'Habitaciones listas',
        trackedRooms: 'Habitaciones registradas',
        error: 'Algo sali\u00f3 mal. Intente de nuevo.',
        selectSector: '\u00bfQu\u00e9 viene a hacer?',
        selectSectorHint: 'Elija su \u00e1rea para continuar',
        notAuthorizedSector: 'No tiene autorizaci\u00f3n para esta \u00e1rea. Elija otra.',
        goodMorning: 'Buenos d\u00edas',
        goodAfternoon: 'Buenas tardes',
        goodEvening: 'Buenas noches',
        entering: 'Entrando a',
        roomDetails: 'Detalles de la habitaci\u00f3n',
        requestDetail: 'Detalle de la solicitud',
        tapForDetails: 'Toque para ver el detalle completo',
        createdLabel: 'Solicitada',
        seenLabel: 'Vista / recibida',
        resolvedLabel: 'Resuelta',
        responseTime: 'Tiempo de respuesta',
        resolutionTime: 'Tiempo de resoluci\u00f3n',
        notFinished: 'A\u00fan no',
        clearHistory: 'Borrar historial',
        historyCleared: 'Historial borrado de este dispositivo. Los registros se conservan para los gerentes.',
        routeElsewhere: 'Enviar a otro departamento',
        routeTitle: '¿A dónde debe ir?',
        routeHelp: 'Sale de su lista y llega a la de ellos. El huésped sigue viendo la misma solicitud.',
        routeConfirm: 'Enviar',
        routeCancel: 'Cancelar',
        routeReasonPlaceholder: '¿Por qué la envía? (opcional)',
        routeFailed: 'No se pudo enviar. Inténtelo de nuevo.',
        hkRequests: 'Solicitudes',
        hkRequestsHelp: 'Solicitudes de huéspedes dirigidas a limpieza',
        dept: {
            housekeeping: 'Limpieza', security: 'Seguridad', concierge: 'Solicitudes',
            maintenance: 'Mantenimiento', parking: 'Estacionamiento', waste_recycling: 'Residuos y reciclaje',
            amenities: 'Comodidades', building: 'Edificio', valet: 'Valet', management: 'Dirección',
        },
        sectorOpenBtn: 'Abrir',
        notifSuffix: 'abiertas',
        noEventsYet: 'Sin actividad todav\u00eda',
        guest: 'Hu\u00e9sped',
        vacant: 'Sin hu\u00e9sped activo',
        checkOut: 'Salida',
        noActivity: 'Sin actividad todav\u00eda',
        viewDetails: 'Ver detalles',
        firstTimeSetup: '\u00bfPrimera vez? Crear PIN',
        forgotPin: '\u00bfOlvid\u00f3 su PIN?',
        setupTitle: 'Cree su PIN de personal',
        setupPrompt: 'Confirme su correo de trabajo y elija un PIN \u00fanico de 4 d\u00edgitos.',
        emailPlaceholder: 'Correo de trabajo',
        newPinPlaceholder: 'Nuevo PIN de 4 d\u00edgitos',
        confirmPinPlaceholder: 'Confirmar PIN',
        createPin: 'Crear PIN',
        pinMismatch: 'Los PIN no coinciden. Int\u00e9ntelo de nuevo.',
        pinExists: 'Ya existe un PIN para esta cuenta. Use \u00abOlvid\u00f3 su PIN\u00bb para restablecerlo.',
        emailNotRecognized: 'Ese correo no se reconoce para este establecimiento. Pida a un administrador que a\u00f1ada su correo.',
        pinCreatedOk: 'PIN creado. Ya puede iniciar sesi\u00f3n con su nuevo PIN.',
        forgotTitle: 'Restablecer su PIN de personal',
        forgotPrompt: 'Ingrese su correo de trabajo y le enviaremos un enlace de restablecimiento seguro.',
        sendResetLink: 'Enviar enlace',
        pinForgotSent: 'Si existe una cuenta con ese correo, se ha enviado un enlace de restablecimiento. Revise su bandeja de entrada.',
        tooManyRequests: 'Demasiadas solicitudes. Int\u00e9ntelo m\u00e1s tarde.',
        pinEmailUnavailable: 'El correo de restablecimiento no est\u00e1 disponible ahora. Contacte a un administrador.',
        resetTitle: 'Crear un nuevo PIN',
        resetPrompt: 'Elija un nuevo PIN de 4 d\u00edgitos. Su PIN anterior dejar\u00e1 de funcionar de inmediato.',
        setNewPin: 'Establecer PIN',
        pinResetOk: 'Su PIN se ha restablecido. Inicie sesi\u00f3n con su nuevo PIN.',
        pinResetInvalid: 'Este enlace de restablecimiento no es v\u00e1lido o ha expirado. Solicite uno nuevo.',
    },
};
